/**
 * Configuration déclarative pour l'entité Discount
 * Source unique de vérité pour tous les champs de Discount
 */

import type { Discount } from '../../types/discount';
import { defineEntityConfig } from '../../lib/entity-config';

export const DISCOUNT_CONFIG = defineEntityConfig<Discount>({
  entityName: 'réduction',
  entityNamePlural: 'réductions',

  fields: {
    name: {
      key: 'name',
      label: 'Nom',
      type: 'text',
      required: true,
      sortable: true,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
      size: 250,
      importValidation: (value) => {
        if (typeof value !== 'string') return 'Le nom doit être une chaîne de caractères';
        if (value.length < 3) return 'Le nom doit contenir au moins 3 caractères';
        return true;
      },
    },

    amount: {
      key: 'amount',
      label: 'Montant (€)',
      type: 'number',
      required: true,
      sortable: true,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
      size: 150,
      exportTransform: (value: number) => (value ? `${value.toFixed(2).replace('.', ',')} €` : ''),
      importTransform: (value: string) => {
        // Accepte "100", "100.50", "100,50", "100 €", "100,50 €"
        const cleaned = value.replace(/[€\s]/g, '').replace(',', '.');
        return parseFloat(cleaned) || 0;
      },
      importValidation: (value) => {
        if (typeof value !== 'number' || isNaN(value)) return 'Le montant doit être un nombre';
        if (value < 0) return 'Le montant doit être positif';
        return true;
      },
    },

    status: {
      key: 'status',
      label: 'Statut',
      type: 'enum',
      enumValues: ['Active', 'Inactive'] as const,
      required: true,
      sortable: true,
      editable: true,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
      size: 120,
      importTransform: (value: string) => {
        // Accepte "Active", "active", "Actif", "actif"
        const normalized = value.toLowerCase();
        if (normalized === 'active' || normalized === 'actif') return 'Active';
        if (normalized === 'inactive' || normalized === 'inactif') return 'Inactive';
        return 'Active'; // Défaut
      },
    },
  },
});
